'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = initialize;

var _config = require('./config');

function initialize(config) {
    _config.Configuration.setConfig(config);
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/index.js
// module id = 745
// module chunks = 0